import { Component, OnInit } from '@angular/core';
import { RedirectService } from 'app/services/page/redirect.service';

@Component({
    templateUrl: 'redirect.component.html'
})
export class RedirectView implements OnInit {

    constructor(private redirectService: RedirectService) { }

    ngOnInit(): void {
        this.redirectService.redirect();
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/pages/redirect.component.ts